<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path class="fil0" d="M3481.63 1237.05c-477.53,499.16 -980.71,1068.9 -1474.12,1540.91 -112.06,117.14 -299.55,121.29 -416.69,9.22 -480.64,-459.75 -1002.13,-1065.96 -1474.13,-1559.36 -112.06,-117.14 -107.91,-304.63 9.23,-416.7 117.14,-112.05 304.65,-107.92 416.72,9.24l1260.94 1318.07 1252.11 -1308.84c112.07,-117.16 299.58,-121.3 416.72,-9.24 117.14,112.06 121.29,299.55 9.22,416.7z"/>
 </g>
</svg>
